import axios from 'axios';
import mainService from './mainService';
const CancelToken = axios.CancelToken;

let requestDataCancel;

export function metOceanRecords(portId: number, data: object) {
    return mainService
        .post(`metOcean/records`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function metOceanAtTime(portId: number, data: object) {
    if (requestDataCancel !== undefined) {
        requestDataCancel();
    }

    return mainService
        .post(`metOcean/atTime`, data, {
            cancelToken: new CancelToken(function executor(c) {
                requestDataCancel = c;
            }),
        })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
